import React from 'react';
import { Sparkles, SquarePen } from 'lucide-react';

interface AICalloutActionBannerProps {
  title: string;
  description: string;
  children?: React.ReactNode;
}

export const AICalloutActionBanner: React.FC<AICalloutActionBannerProps> = ({
  title,
  description,
  children
}) => {
  return (
    <div className="rounded-lg border border-gray-100 shadow-sm bg-gradient-to-r from-gray-50 via-purple-50 to-pink-50 p-6 mb-4">
      <div className="flex items-center justify-between">
        {/* Left side - Icon and content */}
        <div className="flex items-center gap-4">
          <div className="bg-blue-100 p-3 rounded-full border border-blue-200">
            <SquarePen className="w-6 h-6 text-blue-600" />
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {title}
            </h3>
            <p className="text-xs text-gray-600 mt-1 max-w-lg">
              {description}
            </p>
          </div>
        </div>

        {/* Right side - Children (button area) */}
        {children && (
          <div className="flex-shrink-0 ml-4">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};
